import { Link } from '@tanstack/react-router'

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { m } from '@/lib/paraglide/messages'

// View-model hợp nhất cho pool tài xế: đơn bán và đơn giao hợp đồng.
export interface AvailableCard {
    kind: 'sale' | 'contract'
    id: string
    code: string
    recipientName: string
    phone: string
    address: string
    // Chỉ đơn bán có nhãn tiền/COD. Đơn hợp đồng KHÔNG có.
    amountLabel?: string
}

export function AvailableOrderCard({ card }: { card: AvailableCard }) {
    return (
        <Card className="hover:border-primary transition-colors">
            <CardHeader className="pb-2">
                <div className="flex items-start justify-between gap-2">
                    <CardTitle className="text-sm font-medium">
                        {card.code}
                    </CardTitle>
                    <Badge
                        variant={card.kind === 'contract' ? 'warning' : 'secondary'}
                        className="shrink-0 text-xs"
                    >
                        {card.kind === 'contract' ? m.cdo_kind_contract() : m.cdo_kind_sale()}
                    </Badge>
                </div>
            </CardHeader>
            <CardContent className="space-y-1.5 text-sm">
                <p className="font-medium">{card.recipientName}</p>
                <p className="text-muted-foreground text-xs">{card.phone}</p>
                <p className="text-muted-foreground text-xs line-clamp-2">
                    {card.address}
                </p>
                {card.kind === 'sale' && card.amountLabel && (
                    <p className="font-semibold text-primary">{card.amountLabel}</p>
                )}
                <div className="pt-1">
                    {card.kind === 'sale' ? (
                        <Link to="/orders/$orderId" params={{ orderId: card.id }}>
                            <Button size="sm" variant="outline" className="w-full">
                                {m.cdo_view_detail()}
                            </Button>
                        </Link>
                    ) : (
                        <Link
                            to="/contract-deliveries/$id"
                            params={{ id: card.id }}
                        >
                            <Button size="sm" variant="outline" className="w-full">
                                {m.cdo_view_detail()}
                            </Button>
                        </Link>
                    )}
                </div>
            </CardContent>
        </Card>
    )
}
